import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { FlashMessagesComponent } from './flash-messages.component';
import { FlashMessagesService } from './flash-messages.service';

@NgModule({
  declarations: [FlashMessagesComponent],
  exports: [FlashMessagesComponent],
  imports: [CommonModule],
  providers: [],
})
export class FlashMessagesModule {
  static forRoot(): ModuleWithProviders<FlashMessagesModule> {
    return {
      ngModule: FlashMessagesModule,
      providers: [FlashMessagesService],
    };
  }
}
